import React, { useContext, useMemo } from 'react';
import cx from 'classnames';
import { uniqueInnerId } from '@jutro/platform';
import { TranslatorContext } from '@jutro/locale';
import styles from './BrandedLoader.module.css';
import { messages } from './BrandedLoader.messages';
export function BrandedLoader() {
  const translator = useContext(TranslatorContext);
  const {
    labelId
  } = uniqueInnerId('BrandedLoader', 'labelId');
  const cubes = useMemo(() => {
    return Array.from({
      length: 9
    }, (_, index) => {
      const cubeClasses = cx(styles.brandedLoaderElement, styles["brandedLoaderElement-".concat(index + 1)]);
      return React.createElement('div', {
        key: "cube_".concat(index),
        className: cubeClasses
      });
    });
  }, []);
  return React.createElement('div', {
    className: 'loaderContainer'
  },
  // Wrap the loader in the container
  React.createElement('div', {
    className: styles.brandedLoader,
    'aria-labelledby': labelId
  }, cubes), React.createElement('div', {
    id: labelId,
    className: styles.screenReaderOnly
  }, translator(messages.loading)));
}
BrandedLoader.displayName = 'BrandedLoader', BrandedLoader.__docgenInfo = {
  description: 'BrandedLoader is default loader element for Loader component',
  methods: [],
  displayName: 'BrandedLoader'
}, BrandedLoader.__docgenInfo = {
  componentName: 'BrandedLoader',
  packageName: '@jutro/components',
  description: 'BrandedLoader is default loader element for Loader component',
  displayName: 'BrandedLoader',
  methods: [],
  actualName: 'BrandedLoader'
};